export const visit = (vm, at) => {
at({ "da": { "conversations-visitor-experience-components": { "emailCapture": { "failedToPublish": "Vi kunne desv\xE6rre ikke bekr\xE6fte din e-mail-adresse." } } } });
};